import { TASK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
import { ACTIVITY_FILTERS } from '../../permissions/gates';
const Task = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated(ACTIVITY_FILTERS),
  objectTypeId: TASK_TYPE_ID,
  referenceObjectType: 'TASK_PROPERTIES'
});
export default Task;